/* GENERATED FILE — DO NOT EDIT.
 *
 * The engine's exercise-name abbreviations, emitted from the table the app compiles:
 *   HybridTrainer/Services/AI/ExerciseNameVocabulary.swift  (`abbreviations`, `searchable`)
 *
 * Regenerate:  KATA_EMIT_WEB_TOKENS=1 ./tools/engine-tests/run.sh
 * The harness gate `w72-5-the-library` regenerates this in memory on every run and fails if it differs.
 *
 * `searchable` APPENDS the long form, never substitutes it, so nothing that matched before can stop matching —
 * the engine's own rule (gate `the-name-that-became-hs`).
 */

export const ABBREVIATIONS: readonly { readonly token: string; readonly expansion: string }[] = [
  { token: "hspu", expansion: "handstand push-up" },
  { token: "hs", expansion: "handstand" },
  { token: "flag", expansion: "human flag" },
  { token: "db", expansion: "dumbbell" },
  { token: "kb", expansion: "kettlebell" },
];

/** The name as the engine searches it: lower-cased, with each present abbreviation's long form appended. */
export function searchable(name: string): string {
  const lower = name.toLowerCase();
  const tokens = new Set(lower.split(/[^\p{L}\p{N}]+/u).filter((t) => t !== ""));
  let out = lower;
  for (const { token, expansion } of ABBREVIATIONS) if (tokens.has(token)) out += ` ${expansion}`;
  return out;
}
